import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function CallStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M20.25 16.6602C20.2499 16.5613 20.1917 16.4719 20.1016 16.4316L16.7608 14.9463C16.6735 14.9076 16.5714 14.9223 16.4981 14.9834L14.4453 16.6943C13.9414 17.114 13.2353 17.2223 12.624 16.9473C11.1558 16.2866 10.0836 15.6617 9.21095 14.7891C8.33827 13.9164 7.71338 12.8443 7.05275 11.376C6.77778 10.7648 6.88593 10.0587 7.30568 9.55469L9.01661 7.50195C9.07773 7.42862 9.0924 7.32648 9.05372 7.23926L7.56837 3.89941L7.53029 3.83789C7.48345 3.78307 7.41428 3.75008 7.33986 3.75H3.98732C3.84427 3.75 3.74662 3.86351 3.75001 3.98047C3.90643 9.36773 5.36586 13.3268 8.01954 15.9805C10.6732 18.6342 14.6323 20.0936 20.0195 20.25L20.0635 20.2461C20.1633 20.2276 20.2498 20.1383 20.25 20.0137V16.6602ZM21.75 20.0137C21.7498 20.9758 20.9641 21.7774 19.9766 21.749C14.3522 21.5857 9.97101 20.053 6.959 17.041C3.94699 14.029 2.41437 9.6488 2.25099 4.02441C2.22231 3.03641 3.02495 2.25 3.98732 2.25H7.33986C7.98839 2.2501 8.57991 2.60818 8.88283 3.17383L8.93947 3.29004L10.4238 6.62988C10.6947 7.23924 10.5958 7.94966 10.169 8.46191L8.45802 10.5146C8.39626 10.5889 8.38626 10.6857 8.41994 10.7607C9.0519 12.1653 9.58798 13.045 10.2715 13.7285C10.955 14.412 11.8347 14.9481 13.2393 15.5801C13.3142 15.6137 13.411 15.6038 13.4854 15.542L15.5381 13.8311C16.0503 13.4042 16.7608 13.3054 17.3701 13.5762L20.71 15.0605C21.3422 15.3415 21.7499 15.9684 21.75 16.6602V20.0137Z"
				fill="currentColor"
			/>
		</svg>
	);
}

CallStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default CallStrokeIcon;
